var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      ref: "orderInfo",
      attrs: {
        "append-to-body": "",
        title: "【" + _vm.info.orderNo + "】" + " 订单详情",
        "close-on-click-modal": false,
        visible: _vm.visible,
        width: "80%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.closeDialog,
      },
    },
    [
      _c(
        "div",
        { staticClass: "order-contain" },
        [
          _c(
            "div",
            { staticClass: "or-steps" },
            [
              _c(
                "el-steps",
                { attrs: { "align-center": "", space: 90 } },
                _vm._l(_vm.info.orderTimePointList, function (item, index) {
                  return _c(
                    "el-step",
                    { key: index, attrs: { title: item.operate } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "font-14 flex-1 text-center",
                          attrs: { slot: "description" },
                          slot: "description",
                        },
                        [_vm._v(_vm._s(item.timePoint))]
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "tk_btn" }, [
            _vm.info.payStatus && _vm.info.payStatus === 2 && !_vm.info.tc
              ? _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "has-permi",
                            rawName: "v-has-permi",
                            value: ["order_ferry_refund"],
                            expression: "['order_ferry_refund']",
                          },
                        ],
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.handleRefund.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("\n          退款\n        ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.ferryStatus
              ? _c(
                  "div",
                  { staticClass: "margin-left-15" },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "has-permi",
                            rawName: "v-has-permi",
                            value: ["ferry_end_trip"],
                            expression: "['ferry_end_trip']",
                          },
                        ],
                        attrs: { type: "danger", size: "small" },
                        on: { click: _vm.handleEndTrip },
                      },
                      [_vm._v("\n          结束行程\n        ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c(
            "div",
            { staticClass: "order-info" },
            [
              _c("span", { staticClass: "title" }, [_vm._v("状态信息")]),
              _c(
                "el-form",
                { attrs: { inline: true, "label-width": "130px" } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "订单编号:" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.info.orderNo) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "城际客运订单编号:" } },
                            [
                              _c("yd-link", {
                                attrs: {
                                  value: _vm.info.intercityOrderNo,
                                  type: "intercityInfo",
                                  need: true,
                                  query: { id: _vm.info.intercityOrderId },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "订单状态:" } },
                            [
                              _c("el-tag", { attrs: { size: "mini" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("statusFilters")(
                                      _vm.info.orderStatus
                                    )
                                  )
                                ),
                              ]),
                              _vm.info.orderStatus === 2
                                ? _c(
                                    "span",
                                    { staticClass: "pl" },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "has-permi",
                                              rawName: "v-has-permi",
                                              value: ["order_ferry_send"],
                                              expression:
                                                "['order_ferry_send']",
                                            },
                                          ],
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                            loading: _vm.btnLoading,
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.handleSend.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  派单\n                "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.info.orderStatus !== 4 &&
                              _vm.info.orderStatus !== 2
                                ? _c(
                                    "span",
                                    { staticClass: "pl" },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "has-permi",
                                              rawName: "v-has-permi",
                                              value: ["order_ferry_reserve"],
                                              expression:
                                                "['order_ferry_reserve']",
                                            },
                                          ],
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                            loading: _vm.btnLoading,
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.handleSend.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  改派\n                "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "同城接单情况:" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.info.acceptOrderStatus) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "order-info" },
            [
              _c("span", { staticClass: "title" }, [_vm._v("乘客信息")]),
              _c(
                "el-form",
                { attrs: { inline: true, "label-width": "130px" } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 28 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "出发地:" } },
                            [
                              _c("yd-link", {
                                attrs: {
                                  value: _vm.info.startAddress,
                                  type: "location",
                                  query: {
                                    longitude: _vm.info.startLongitude,
                                    latitude: _vm.info.startLatitude,
                                    name: _vm.info.startAddress,
                                    lineName: _vm.info.lineName,
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "目的地:" } },
                            [
                              _c("yd-link", {
                                attrs: {
                                  value: _vm.info.endAddress,
                                  type: "location",
                                  query: {
                                    longitude: _vm.info.endLongitude,
                                    latitude: _vm.info.endLatitude,
                                    name: _vm.info.endAddress,
                                    lineName: _vm.info.lineName,
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "预计出发时间:" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.info.orderDepart) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 28 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("el-form-item", { attrs: { label: "公里数:" } }, [
                            _vm._v(_vm._s(_vm.info.distance) + " 公里"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "预计出行人数:" } },
                            [_vm._v(_vm._s(_vm.info.passengerNumber) + " 人")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "乘车人姓名：" } },
                            [
                              _c("span", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.info.passengerName !== null,
                                    expression: "info.passengerName !== null",
                                  },
                                ],
                                domProps: {
                                  textContent: _vm._s(_vm.info.passengerName),
                                },
                              }),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.info.passengerName === null,
                                      expression: "info.passengerName === null",
                                    },
                                  ],
                                },
                                [_vm._v("--")]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "乘车人电话：" } },
                            [
                              _vm.userList.includes(_vm.info.passengerPhone)
                                ? _c("yd-link", {
                                    attrs: {
                                      permi: "user_center_manage",
                                      value: _vm.info.passengerPhone,
                                      url: _vm.phoneUrl(
                                        _vm.info,
                                        _vm.info.passengerPhone
                                      ),
                                      need: true,
                                      type: "userInfo",
                                    },
                                  })
                                : _c("span", [
                                    _vm._v(_vm._s(_vm.info.passengerPhone)),
                                  ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "下单人姓名：" } },
                            [
                              _c("span", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.info.userName !== null,
                                    expression: "info.userName !== null",
                                  },
                                ],
                                domProps: {
                                  textContent: _vm._s(_vm.info.userName),
                                },
                              }),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.info.userName === null,
                                      expression: "info.userName === null",
                                    },
                                  ],
                                },
                                [_vm._v("--")]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "下单人电话：" } },
                            [
                              _vm.userList.includes(_vm.info.userPhone)
                                ? _c("yd-link", {
                                    attrs: {
                                      permi: "user_center_manage",
                                      value: _vm.info.userPhone,
                                      url: _vm.phoneUrl(
                                        _vm.info,
                                        _vm.info.userPhone
                                      ),
                                      need: true,
                                      type: "userInfo",
                                    },
                                  })
                                : _c("span", [
                                    _vm._v(_vm._s(_vm.info.userPhone)),
                                  ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("el-form-item", { attrs: { label: "备注:" } }, [
                            _c("span", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.info.orderRemark !== null,
                                  expression: "info.orderRemark !== null",
                                },
                              ],
                              domProps: {
                                textContent: _vm._s(_vm.info.orderRemark),
                              },
                            }),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.info.orderRemark === null,
                                    expression: "info.orderRemark === null",
                                  },
                                ],
                              },
                              [_vm._v("--")]
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "订单来源:" } },
                            [_vm._v(_vm._s(_vm.info.orderOrigin))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "order-info" }, [
            _c("div", { staticClass: "title" }, [_vm._v("交易信息")]),
            _c(
              "div",
              { staticStyle: { padding: "0 0 0 20px" } },
              [
                _c("div", { staticClass: "margin-x-20 margin-top-10" }, [
                  _c("span", { staticClass: "margin-right-10" }, [
                    _vm._v("已付金额：" + _vm._s(_vm.info.paySuccessAmount)),
                  ]),
                  _c("span", { staticClass: "margin-right-10" }, [
                    _vm._v("已退金额：" + _vm._s(_vm.info.refundSuccessAmount)),
                  ]),
                  _c("span", [
                    _vm._v(
                      "订单剩余金额：" + _vm._s(_vm.info.refundSurplusAmount)
                    ),
                  ]),
                ]),
                _c(
                  "el-table",
                  {
                    attrs: {
                      data: _vm.info.transactionInfo,
                      border: "",
                      "max-height": "350px",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "transactionType",
                        label: "交易类型",
                        align: "center",
                        width: "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "merchantOrderNo",
                        label: "商户单号(微信截图-短)",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "transactionOrderNo",
                        label: "交易单号(三方)",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "amount", label: "金额", align: "center" },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "transactionTime",
                        label: "时间",
                        align: "center",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "order-info" }, [
            _c("span", { staticClass: "title" }, [_vm._v("服务信息")]),
            _c(
              "div",
              { staticStyle: { padding: "10px 0 0 20px" } },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.info.driverOperationInfoList,
                      border: "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "供应商信息", prop: "merchantName" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "司机姓名", prop: "driverName" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c("yd-link", {
                                attrs: {
                                  permi: "driver_data_normal",
                                  value: row.driverName,
                                  url:
                                    "/data-analysis/driver-data/normal/detail/" +
                                    row.driverId,
                                  type: "userInfo",
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "司机手机号码", prop: "driverPhone" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "车牌号", prop: "plateNumber" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c("yd-link", {
                                attrs: {
                                  permi: "vehicle_view",
                                  value: row.plateNumber,
                                  type: "vehicleDetail",
                                  query: { id: row.carId },
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "司机类型", prop: "driverType" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "归属供应商", prop: "merchantName" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "接单时间", prop: "time" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "状态", align: "center" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("el-tag", { attrs: { size: "mini" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("serviceStatusFilter")(
                                      scope.row.operationStatus
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "备注", prop: "operationRemark" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.orderStatus !== 4
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                            loading: _vm.btnLoading,
                                          },
                                          on: { click: _vm.handleSend },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  改派\n                "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "order-info" }, [
            _c("span", { staticClass: "title" }, [_vm._v("退款信息")]),
            _c(
              "div",
              { staticStyle: { padding: "10px 0 0 20px" } },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.info.orderRefundInfoList, border: "" },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: "编号",
                        prop: "orderNo",
                        width: "130",
                        align: "left",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "退款时间",
                        prop: "successTime",
                        width: "180",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "退款金额",
                        prop: "refundAmount",
                        width: "100",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "退款类型",
                        prop: "source",
                        width: "120",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("el-tag", { attrs: { size: "mini" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("sourceStatusFilter")(
                                      scope.row.source
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "违约金",
                        prop: "serviceCharge",
                        width: "80",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "操作人",
                        prop: "createUserName",
                        width: "80",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "备注", prop: "remark", align: "center" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "order-info" },
            [
              _c("span", { staticClass: "title" }, [_vm._v("开票信息")]),
              _c(
                "span",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end",
                  },
                },
                [
                  _vm.info.invoiceState === 1
                    ? _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.handleResetRed },
                        },
                        [_vm._v("\n          红冲\n        ")]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.handleReset },
                    },
                    [_vm._v("开票重置")]
                  ),
                ],
                1
              ),
              _c(
                "el-form",
                { attrs: { inline: true, "label-width": "110px" } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "开票流水号:" } },
                            [
                              _c("span", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.info.serialNo !== null,
                                    expression: "info.serialNo !== null",
                                  },
                                ],
                                domProps: {
                                  textContent: _vm._s(_vm.info.serialNo),
                                },
                              }),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.info.serialNo === null,
                                      expression: "info.serialNo === null",
                                    },
                                  ],
                                },
                                [_vm._v("--")]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "开票状态:" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.info.invoiceStatusStr) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "开票金额:" } },
                            [_vm._v(_vm._s(_vm.info.invoiceAmount) + " 元")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "开票类型:" } },
                            [
                              _c("span", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.info.invoiceType !== null,
                                    expression: "info.invoiceType !== null",
                                  },
                                ],
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.info.invoiceType | _vm.invoTypeFilter
                                  ),
                                },
                              }),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.info.invoiceType === null,
                                      expression: "info.invoiceType === null",
                                    },
                                  ],
                                },
                                [_vm._v("--")]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "开票信息:" } },
                            [
                              _c("span", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.info.invoiceTitle !== null,
                                    expression: "info.invoiceTitle !== null",
                                  },
                                ],
                                domProps: {
                                  textContent: _vm._s(_vm.info.invoiceTitle),
                                },
                              }),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.info.invoiceTitle === null,
                                      expression: "info.invoiceTitle === null",
                                    },
                                  ],
                                },
                                [_vm._v("--")]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "开票用户:" } },
                            [
                              _c("span", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.info.invoiceUserPhone !== null,
                                    expression:
                                      "info.invoiceUserPhone !== null",
                                  },
                                ],
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.info.invoiceUserPhone
                                  ),
                                },
                              }),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.info.invoiceUserPhone === null,
                                      expression:
                                        "info.invoiceUserPhone === null",
                                    },
                                  ],
                                },
                                [_vm._v("--")]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "开票时间:" } },
                            [
                              _c("span", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.info.invoiceCreateTime !== null,
                                    expression:
                                      "info.invoiceCreateTime !== null",
                                  },
                                ],
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.info.invoiceCreateTime
                                  ),
                                },
                              }),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.info.invoiceCreateTime === null,
                                      expression:
                                        "info.invoiceCreateTime === null",
                                    },
                                  ],
                                },
                                [_vm._v("--")]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "申请时间:" } },
                            [
                              _c("span", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.info.applyTime !== null,
                                    expression: "info.applyTime !== null",
                                  },
                                ],
                                domProps: {
                                  textContent: _vm._s(_vm.info.applyTime),
                                },
                              }),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.info.applyTime === null,
                                      expression: "info.applyTime === null",
                                    },
                                  ],
                                },
                                [_vm._v("--")]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticStyle: { margin: "20px 0 10px 0" },
              attrs: {
                loading: _vm.logLoading,
                size: "small",
                type: "primary",
              },
              on: { click: _vm.showLogData },
            },
            [
              _vm._v("\n      操作日志\n      "),
              !_vm.showLog
                ? _c("i", { staticClass: "el-icon-arrow-right" })
                : _c("i", { staticClass: "el-icon-arrow-down" }),
            ]
          ),
          _c(
            "transition",
            { attrs: { name: "el-fade-in-linear" } },
            [
              _c("operation-log", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showLog,
                    expression: "showLog",
                  },
                ],
                attrs: {
                  visible: _vm.showLog,
                  type: 3,
                  flightPlanId: _vm.info.orderId,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showRefundDialog
        ? _c("order-refund", {
            ref: "refund",
            on: { refresh: _vm.handleRefresh },
          })
        : _vm._e(),
      _vm.showSendDialog
        ? _c("order-send", { ref: "send", on: { refresh: _vm.handleRefresh } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }